export default "<toaster-container [toasterconfig]=\"toasterconfig\"></toaster-container>\n";